import { Form } from "react-final-form";
import { onSubmit, onValidate } from "./LeasingFormSubmit";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@emotion/react";

import { useEffect, useState } from "react";
import LeasingFormStepOne from "./LeasingFormSteps/LeasingFormStepOne";
import LeasingFormStepTwo from "./LeasingFormSteps/LeasingFormStepTwo";

const LeasingForm = (props) => {
  const theme = useTheme();
  const { step, setStep, update, initialValues: _initialValues } = props;
  const [initialValues, setInitialValues] = useState(null);

  useEffect(() => {
    if (update) {
      setInitialValues({
        ..._initialValues,
        leasingType: _initialValues?.leasingType?.uuid
          ? { value: _initialValues?.leasingType?.uuid }
          : null,
      });
      return;
    }

    setInitialValues({});
    // eslint-disable-next-line
  }, []);

  return (
    <Form
      initialValues={initialValues}
      onSubmit={(val) => onSubmit(val, props)}
      validate={(val) => onValidate(val, props)}
      validateOnBlur={false}
    >
      {(formProps) => {
        return (
          <form
            id={props.formName}
            onSubmit={formProps.handleSubmit}
            className="LeasingForm"
          >
            <SwipeableViews
              axis={theme.direction === "rtl" ? "x-reverse" : "x"}
              index={step}
              onChangeIndex={(index) => setStep(index)}
            >
              <LeasingFormStepOne {...formProps} {...props} />
              <LeasingFormStepTwo {...formProps} {...props} />
            </SwipeableViews>
          </form>
        );
      }}
    </Form>
  );
};

export default LeasingForm;
